/* eslint-disable max-lines-per-function */
import { useTranslation } from 'react-i18next';

import {
  ColorPickerFormField,
  DatePickerFormField,
  InputFormField,
  RepetitionIntervalFormField,
  TimeInputFormField,
} from '@/domain/termine/features/CreateTermin/Sheet/components';
import { useCreateTermineFormContext } from '@/domain/termine/features/CreateTermin/shared/useCreateTermineFormContext';
import { TextAreaFormField } from '@/domain/termine/features/CreateTermin/Sheet/components/FormFields/TextAreaFormField';
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { UploadTerminImage } from '@/domain/termine/components/TerminImage/UploadTerminImage';
import { useCallback } from 'react';

export function CreateTermineFormContent() {
  const { t } = useTranslation();
  const { form } = useCreateTermineFormContext();

  const [showSpecials, setShowSpecials] = useState(false);

  const [terminBild, markierung] = form.watch(['terminBild', 'markierung']);

  const handleFileSelect = useCallback(
    (file: File | null) => {
      if (file) {
        form.setValue('terminBild', {
          file,
          name: file.name,
          contentType: file.type,
        });
      } else {
        form.setValue('terminBild', null);
      }
    },
    [form],
  );

  return (
    <div className="flex flex-col gap-4 p-6 h-full">
      <span className="font-normal text-neutrals-N700 text-xs">
        {t('domain.termine.sheet.pflichtfelder')}
      </span>
      <div className="flex flex-col flex-1 gap-4">
        <div className="flex flex-col flex-1">
          <UploadTerminImage
            image={terminBild}
            variant="sheet"
            markierung={markierung}
            className="text-neutrals-N700"
            onFileSelect={handleFileSelect}
          />
          <div className="flex flex-col gap-4 flex-1">
            <div className="flex row gap-4">
              <InputFormField form={form} />
              <ColorPickerFormField form={form} />
            </div>

            <div className="flex flex-row gap-4">
              <DatePickerFormField form={form} name="datum" />
              <TimeInputFormField form={form} name="beginn" />
              <TimeInputFormField form={form} name="ende" />
            </div>
            <div className="flex flex-row">
              <RepetitionIntervalFormField form={form} />
            </div>
            <TextAreaFormField form={form} name="beschreibung" />

            {!showSpecials && (
              <Button
                type="button"
                variant="ghost-primary"
                className="self-start w-auto"
                onClick={() => setShowSpecials(true)}>
                <span className="text-sm">
                  {t('domain.termine.addAdditionalInformation')}
                </span>
              </Button>
            )}
            {showSpecials && <TextAreaFormField form={form} name="specials" />}
          </div>
        </div>
      </div>
    </div>
  );
}
